// extracted by mini-css-extract-plugin
module.exports = {"switch":"a2c79c7e7d--switch--CQEnX","indicator":"a2c79c7e7d--indicator--kueqN","label":"a2c79c7e7d--label--hfzMb"};